export interface AppConfigInterface {
  partnerId?: string;
  showAdvancedFeatures?: boolean;
  showIncludedTemplates?: boolean;
  showDomainsFeatures?: boolean;
  showImportFeatures?: boolean;
  showBackupsFeatures?: boolean;
  showStagingFeatures?: boolean;
}

export interface GetAppConfigRequestInterface {
  partnerId?: string;
}

export interface GetAppConfigResponseInterface {
  config?: AppConfigInterface;
}

export class AppConfig implements AppConfigInterface {
  partnerId: string;
  showAdvancedFeatures: boolean;
  showIncludedTemplates: boolean;
  showDomainsFeatures: boolean;
  showImportFeatures: boolean;
  showBackupsFeatures: boolean;
  showStagingFeatures: boolean;

  static fromProto(proto: any): AppConfig {
    let m = new AppConfig();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: AppConfigInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.showAdvancedFeatures !== 'undefined') {
      toReturn['showAdvancedFeatures'] = this.showAdvancedFeatures;
    }
    if (typeof this.showIncludedTemplates !== 'undefined') {
      toReturn['showIncludedTemplates'] = this.showIncludedTemplates;
    }
    if (typeof this.showDomainsFeatures !== 'undefined') {
      toReturn['showDomainsFeatures'] = this.showDomainsFeatures;
    }
    if (typeof this.showImportFeatures !== 'undefined') {
      toReturn['showImportFeatures'] = this.showImportFeatures;
    }
    if (typeof this.showBackupsFeatures !== 'undefined') {
      toReturn['showBackupsFeatures'] = this.showBackupsFeatures;
    }
    if (typeof this.showStagingFeatures !== 'undefined') {
      toReturn['showStagingFeatures'] = this.showStagingFeatures;
    }
    return toReturn;
  }
}

export class GetAppConfigRequest implements GetAppConfigRequestInterface {
  partnerId: string;

  static fromProto(proto: any): GetAppConfigRequest {
    let m = new GetAppConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: GetAppConfigRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}

export class GetAppConfigResponse implements GetAppConfigResponseInterface {
  config: AppConfig;

  static fromProto(proto: any): GetAppConfigResponse {
    let m = new GetAppConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = AppConfig.fromProto(proto.config);
    }
    return m;
  }

  constructor(kwargs?: GetAppConfigResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? (this.config as any).toApiJson() : this.config;
    }
    return toReturn;
  }
}
